<template>
  <div class="live-wrapper">
    <!--    视频-->
    <div class="lp-player-box">
      <!--video属性
                 webkit-playsinline ios 小窗播放，使视频不脱离文本流，安卓则无效
                 微信内置x5内核，
                 x5-video-player-type="h5-page" 启用H5播放器,是wechat安卓版特性，添加此属性，微信浏览器会自动将视频置为全屏
                 x5-video-player-fullscreen="true" 全屏设置，设置为 true 是防止横屏
                 x5-video-orientation 控制横竖屏 landscape 横屏，portrain竖屏； 默认portrain
                 poster：封面
                 src：播放地址
                 -->
      <video id="video"
        ref="myVideo"
        :poster="video_cover"
        :src="video_src" preload="auto" webkit-playsinline="true" playsinline="true" x-webkit-airplay="allow" x5-video-player-type="h5"
        x5-video-player-fullscreen="true" x5-video-orientation
        class="video-box" loop
             :playOrPause="playOrPause"
             @click="pauseVideo" @ended="onPlayerEnded($event)"
      ></video>
    </div>
    <!-- 封面 -->
<!--    <img v-show="isVideoShow" class="play" @click="playvideo" :src="video_cover"/>-->
    <!-- 播放暂停按钮 -->
<!--    <img v-show="iconPlayShow" class="icon_play" @click="playvideo"-->
<!--         src="http://npjy.oss-cn-beijing.aliyuncs.com/images/file-1575340653940esdHR.png"/>-->
        <div v-show="iconPlayShow" class="lp-player-btn" v-if="video_is_show" @click="playvideo">
          <van-icon size="50" name="play-circle-o" />
        </div>

    <!-- 播放按钮 -->
<!--    <div class="lp-player-btn" v-if="video_is_show" @click="play">-->
<!--      <van-icon size="50" name="play-circle-o" />-->
<!--    </div>-->
    <!--    顶部-->
    <div id="lp-header">
      <!-- 标题 在线人数 点赞 留言数 -->
      <div class="lp-ht-row justify-align">
        <span style="padding-left: 2.66667vw;">
          <van-icon @click="goPage" name="arrow-left" />
          <strong><van-notice-bar color="#ffffff" background="none" :text="video_title"/></strong>
        </span>
<!--        <span>-->
<!--          <van-icon style="margin-right: 0.66667vw;" name="friends-o" />3193-->
<!--        </span>-->
<!--        <span>-->
<!--          <van-icon style="margin-right: 0.66667vw;" name="comment-o" />3193-->
<!--        </span>-->
        <div class="left-justifying rt-box">
          <img @click="goVr" v-if="live_info.vr_url != null" class="vr-img" src="../../assets/zhibo_vr_des.png" alt="" />
          <div class="left-justifying">
          <img src="../../assets/zhibo_wode.png" alt="" />
          <span>1233</span> <span class="hint-num">播放</span>
           </div>
        </div>

      </div>
    </div>
    <!-- 左1按钮分组 -->
    <div class="lp-icon-group" id="lp-icon-1">
      <div class="lp-icon-item" @click="clickShowBag"><img src="../../assets/zhibo_red1.png" alt=""></div>
      <!-- 1元购物 -->
      <div class="lp-icon-item"><img src="../../assets/zhibo_red2.png" alt=""></div>
      <!-- 优惠券 -->
      <div class="lp-icon-item"><img src="../../assets/zhibo_red3.png" alt=""></div>
<!--      <div class="coupon-icon">-->
<!--        <span>0</span>-->
<!--      </div>-->
      <!-- 红包 -->
      <div class="lp-icon-item"><img src="../../assets/zhibo_red4.png" alt=""></div>
<!--      &lt;!&ndash; 付费礼物 &ndash;&gt;-->
<!--      <div class="lp-icon-item"><img src="../../assets/zhibo_red1.png" alt=""></div>-->
    </div>
    <!-- 左1按钮分组end -->
    <!-- 右3按钮分组 -->
    <div id="lp-icon-4" class="lp-icon-group">
      <div class="lp-icon-item"><img src="../../assets/des_aixin.png" alt="">1223</div>
      <!-- 1元购物 -->
      <div class="lp-icon-item"><img src="../../assets/zhibo_pl.png" alt="">8888</div>
      <!-- 优惠券 -->
      <div class="lp-icon-item"><img src="../../assets/zhibo_fd.png" alt=""></div>
      <!-- 红包 -->
      <div class="lp-icon-item"><img src="../../assets/zhibo_img.png" alt=""></div>
      <div class="lp-icon-item"><img src="../../assets/zhibo_xian.png" alt=""></div>
      <div class="lp-icon-item"><img src="../../assets/zhibo_share.png" alt=""></div>
    </div>
    <!-- 右3按钮分组end -->
    <!-- 弹框-->
    <div id="panel-wrapper" class="panel-wrapper" v-if="panel_is_show">
      <div class="close-btn" @click="panel_is_show=false"><span>关闭</span></div>
      <div class="panel">
        <div class="panel-title">
          <div class="panel-title">
            <span :class="activeNav == 0?'current':''" @click="tabChange(0)">人机互动</span>
            <span :class="activeNav == 1?'current':''" @click="tabChange(1)">详情介绍</span>
            <span :class="activeNav == 2?'current':''" @click="tabChange(2)">共享照片</span>
            <span :class="activeNav == 3?'current':''" @click="tabChange(3)">富豪赏榜</span>
          </div>
        </div>
        <div class="panel-content" id="live-ranking-list-box">
          <div id="live-ranking-list1" v-if="activeNav==0">
<!--           信息-->
            <div class="live-chat-msgs" :class="[ faceShow? 'msg-height':'' ]">
              <div class="item" style="align-items: start;" v-for="(item,index) in content" :key="index">
                <div class="left-justifying">
                  <div class="item-left">
                    <img src="" class="img-circle" alt="" />
                  </div>
                  <div class="item-right">
                    <div class="item-top justify-align">
                      <div class="item-name">人可何</div>
                      <div class="translate left-justifying">
                        <div class="tran active">中文</div><div class="tran">EN</div><div class="tran">多国语言</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="item-content">
                  <div class="item-txt">{{item}}</div>
                </div>
              </div>
            </div>
<!--            聊天end-->
            <!-- 输入框区域box -->
            <div class="input-box" ref="heightFace">
              <!-- 输入框区域 -->
              <div class="input-content left-justifying">
                        <van-icon size="24" color="#fff" @click="faceContent" name="smile-o" />
                <input v-model="textConent" class="input-txt" type="text" />
                <!--        <van-icon size="24" color="#fff" @click="referContent" name="back-top" />-->
                <div class="send-btn" @click="referContent" name="back-top">发送</div>
              </div>
              <!-- 表情区域 -->
                <div class="browBox" v-if="faceShow">
                  <ul>
                    <li v-for="(item,index) in faceList" :key="index" @click="getBrow(index)">{{item}}</li>
                  </ul>
                </div>
            </div>
          </div>
          <div id="live-ranking-list2" class="live-ranking-list" v-else-if="activeNav==1">
            详情介绍
          </div>
          <div id="live-ranking-list3" class="live-ranking-list" v-else-if="activeNav==2">
            共享照片
          </div>
          <div id="live-ranking-list4" class="live-ranking-list" v-else>
            富豪赏榜
          </div>
        </div>
      </div>
    </div>
    <!-- 弹框end-->
    <!--    消息-->
    <div class="fake-chat-msg">
      <div class="fake-chat-inner">
        <div class="item">
          <span>name：</span>
          <span>测试</span>
        </div>
      </div>
    </div>
    <!--说点什么-->
    <div id="fake-chat-form" @click="panelShow" v-if="panel_is_show==false">
      说点什么
    </div>
    <div class="gift-box" @click="panelShowGift"><img src="../../assets/zhibo_liwu.png" alt="" /></div>
    <!--  购物袋-->
    <van-action-sheet v-model="shopBig" title=" " :closeable="true" :overlay="false">
      <div class="content-pop">
        <div class="p-title-box justify-align">
          <span class="title">共{{goodsList.length}}件商品</span>
          <div class="left-justifying">
<!--            <div class="pop-item" style="margin-right: 5.33333vw;">-->
<!--              <img src="../../assets/allShop.png" alt="" />-->
<!--              店铺商品-->
<!--            </div>-->
<!--            <div class="pop-item">-->
<!--              <img src="../../assets/shopCar.png" alt="" />-->
<!--              购物车-->
<!--            </div>-->
          </div>
        </div>
        <div class="goods-list-box">
          <div class="goods-item left-justifying" style="align-items: flex-start;" v-for="(item,index) in goodsList" :key="index" @click="goDes(item.id)">
            <div class="goods-img-box">
              <div class="hint-num">{{index+1}}</div>
              <img :src="item.image" alt="" />
            </div>
            <div class="goods-content">
              <div class="goods-title">{{item.name}}</div>
              <div class="goods-des justify-align">
                <div class="price-box">
                  ￥<span>{{item.price}}</span>
                </div>
                <div class="buy-news">马上抢</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-action-sheet>
<!--    购物店end-->
<!--    <div class="border_progress" :style="'width:'+videoProcess+'%'"></div>-->

<!--    礼物弹框-->
    <div class="panel-wrapper" v-if="panel_is_show_gift">
      <div class="close-btn" @click="panel_is_show_gift=false"><span>关闭</span></div>
      <div class="panel">

        <div class="panel-content">
          <div class="gift-list">
            <div class="gift-item" v-for="(item,index) in giftList" :key="index">
              <img src="" alt="" />
              22.00
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 礼物弹框end -->
  </div>
</template>

<script>
import { zhoboListDes } from '@/api/zhibo'
// let videoProcessInterval;
// 导入JSON格式的表情库
const appData = require("@/assets/emojis.json");
export default {
  name: "liveDes",
  data () {
    return {
      giftList:[{},{},{},{},{}],
      panel_is_show_gift:false, // 礼物
      video_cover: require('@/assets/07hot1.png'),
      activeNav: 0,
      panel_is_show: false,
      controls:'',
      video_src:'',
      video_title:'',
      live_id:'',
      live_info:'',
      video_is_show:true,
      inventory_number: 0, // 库存
      shopBig: false, // 购物袋弹框是否显示
      goodsList: [],
      videoProcess: 0,//视频播放进度
      isVideoShow: true,
      playOrPause: true,
      iconPlayShow: true,
      currentTime: 0, // 当前播放时间
      duration: 0 ,// 总时长
      videoProcessInterval:'',
      videoSet: '',
      textConent: "",
      faceList: [],
      faceShow: false,
      getBrowString: "",
      content: ['非常好非常好，非常好非常好，非常好非常好，非常好非常好，非常好非常好，非常好非常好，非常好非常好。',
        '非常好非常好，非常好非常好，非常好非常好，非常好非常好，非常好非常好，非常好非常好，非常好非常好。', 'test'],
    }
  },
  created() {
    this.live_id = this.$route.query.id
    this.getDes()
  },
  mounted(){
    var that = this
    let video = document.getElementById('video')
  },
  methods: {
    goVr(){
      console.log(2222)
      console.log(this.live_info.vr_url)
      // live_info
      var url = this.live_info.vr_url
      window.open(url);
      window.location.href = url
    },
    // 表情
    faceContent() {
      this.faceShow = !this.faceShow;
      if (this.faceShow == true) {
        for (let i in appData) {
          this.faceList.push(appData[i].char);
        }
      } else {
        this.faceList = [];
      }
    },
    // 获取用户点击之后的标签 ，存放到输入框内
    getBrow(index) {
      for (let i in this.faceList) {
        if (index == i) {
          this.getBrowString = this.faceList[index];
          this.textConent += this.getBrowString;
        }
      }
    },
    // 将input的内容渲染到页面上
    referContent() {
      if (this.textConent == "") return alert("请输入内容");
      // 存入
      this.content.push(this.textConent);
      // 清空input数据
      this.textConent = "";
      // 关闭表情列表
      this.faceShow = false;
    },
    // 开始播放
    playvideo(event) {
      let video = document.getElementById('video')
      this.isVideoShow = false;
      this.iconPlayShow = false;
      this.showShareBox = false;
      video.play();
      window.onresize = function () {
        video.style.width = window.innerWidth + "px";
        video.style.height = window.innerHeight + "px";
      }
      this.videoProcessInterval = setInterval(() => {
        this.changeProcess(video)
      }, 100)
      // 通过$once来监听定时器，在beforeDestroy钩子可以被清除。
      this.$once('hook:beforeDestroy', () => {
        clearInterval(this.videoProcessInterval) // 此处的timer即 上文const的 timer
      })
    },
    pauseVideo() { //暂停\播放
      try {
        let video = document.getElementById('video')
        if (this.playOrPause) {
          video.pause();
          this.iconPlayShow = true;
          clearInterval(this.videoProcessInterval)
          console.log('暂停')
        } else {
          // wx.ready(() => {
          //     // 在微信的ready中进行播放 不管成功配置与否 都会执行ready
          //     video.play();
          // })
          console.log('play')
          video.play();
         //  video.pause();
         // this.videoSet  = setTimeout(()=>{
         //    video.play();
         //    this.iconPlayShow = false;
         //    this.videoProcessInterval = setInterval(() => {
         //      this.changeProcess(video)
         //    }, 100)
         //   this.$once('hook:beforeDestroy', () => {
         //     clearInterval(this.videoProcessInterval) // 此处的timer即 上文const的 timer
         //     video.pause();
         //   })
         //
         //  },100)
         //  this.$once('hook:beforeDestroy', () => {
         //    clearTimeout(this.videoSet) // 此处的timer即 上文const的 timer
         //    video.pause();
         //  })
        }
        this.playOrPause = !this.playOrPause;
        this.showShareBox = false;
      } catch (e) {
        alert(e)
      }


    },
    //记录播放进度
    changeProcess() {
      let video = document.getElementById('video')
      // console.log(video.currentTime)
      let currentTime = video.currentTime.toFixed(1);
      this.currentTime = currentTime
      // console.log(video.currentTime.toFixed(1))
      let duration = video.duration.toFixed(1); // // 视频时长
      this.duration = duration
      this.videoProcess = parseInt((this.currentTime / this.duration).toFixed(2) * 100)
    },
    // 获取当前播放位置
    clickShowBag(){ // 点击购物袋
      if (this.goodsList != ''){
        this.shopBig = true
      } else {
        this.$toast('暂无商品')
      }
    },
    goDes(id){
      this.$router.push({path:'/goodDetails',query: {id: id}})
    },
    play(){
      video.play();
      this.video_is_show = false
      this.videoTime()
    },
    videoTime(){
      let video = document.getElementById('video')
      // 视频时长
      var duration = video.duration
      console.log('总时长',duration)
    },
    getDes(){
      zhoboListDes(this.live_id).then(res => {
        if(res.code == 200)
        {
          // console.log('res',res.data)
          this.live_info = res.data
          this.video_src = res.data.play_url
          this.video_cover = res.data.cover
          this.video_title = res.data.title
          this.goodsList = res.data.goods
        }
        else
        {
          this.$toast(res.message)
          this.$router.push('/');
        }
      })
    },
    tabChange(e) {
      this.activeNav = e
    },
    panelShow(){
      this.panel_is_show = true
    },
    panelShowGift(){
      console.log(2222)
      this.panel_is_show_gift = true
    },
    goPage(){
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.icon_play {
  position: absolute;
  top: 44%;
  right: 0;
  left: 0;
  bottom: auto;
  margin: auto;
  z-index: 999;
  height: 120px;width: 20%;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
}

.play, .platStart {
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
}
.border_progress {
  width: 0;
  height: 5px;
  background: #ccc;
  position: absolute;
  bottom: 30px;
  transition: .1s all;z-index: 1;
}
.click-icon{
  position: absolute;left: 50%;top: 50%;
  color: #ea5e2d;z-index: 888;font-size: 50px;
}
.content-pop{

  .p-title-box{
    padding: 20px 100px 20px 20px;
    .title{
      font-weight: bold;
      color: #282828;font-size: 32px;
    }
    .pop-item{
      font-size: 18px;text-align: center;
      img{
        width: 40px;height: auto;display: block;margin: 0 auto;
      }
    }
  }
  .goods-list-box{
    padding: 0 15px 20px;
    .goods-item{
      margin-bottom: 20px;
      .goods-img-box{
        border-radius: 30px; width: 240px;
        height: 240px;overflow: hidden;position: relative;
        img{
          width: 240px;
          height: 240px;display: block;
        }
        .hint-num{
          text-align: center;
          background: rgba(0, 0, 0, 0.5);border-radius: 30px 0px 10px 0px;width: 64px;
          font-size: 22px;font-weight: 400;padding: 10px 0;
          color: #FFFFFF;
          position: absolute;left: 0; top: 0;
        }
      }
      .goods-content{
        width: 450px;margin-left: 20px;position: relative;height: 240px;
        .goods-title{
          text-align: left;font-size: 28px;line-height:40px;
        }
        .goods-des{
          position: absolute;bottom: 0;left: 0;width: 100%;
          .price-box{
            font-weight: 400;
            color: #F23926;
            span{
              font-weight: bold;
              color: #F23926;font-size: 50px;
            }
          }
          .buy-news{
            width: 127px;
            padding: 10px 15px;
            background: #FDD80D;
            border-radius: 32px;font-weight: bold;
            color: #F23926;
          }
        }
      }
    }
  }
}
/deep/ .van-popup{
  background: rgba(255, 255, 255, 0.8);
}
.van-action-sheet__close{
  color: #adadad;
}
.live-wrapper {
  .rt-box{
    padding-right: 20px;
    .vr-img{
      width: 62px;height: auto;
    }
    div{
      background: rgba(0,0,0,0.5);padding: 10px 10px;
      color: #FFFFFF;font-size: 24px;margin-left: 10px;border-radius: 50px;
      img{
        width: 18px;height: auto;margin-left: 4px;margin-right:5px;
      }
      .hint-num{
        font-size: 18px;font-weight: normal;margin-left: 10px;display: inline-block;margin-top: -5px;
      }
    }
  }
  background: #000;
  position: relative;
  .lp-player-box{
    position: relative;
    height: 100vh;
    width: 100%;
    overflow: hidden;
    .video-box{
      z-index: 1;
      position: absolute;
      width: 100%;
      height: 100vh;left: 0;
      object-fit: cover;top: 0;
    }
    .player{
      z-index: 1;
      position: absolute;
      width: 100%;
      height: 100vh;
      object-fit: fill;left: 0;top: 0;
    }
  }
  .lp-player-btn{
    position: absolute;
    width: 100%;
    height: 100vh;
    z-index: 999;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 50px;
    color: #fff;
    background: rgba(0,0,0,.3);top: 0;
  }
  .fake-chat-msg{
    width: 365px;
    position: absolute;
    left: 24px;
    bottom: 120px;
    z-index: 2;
    height: 150px;
    overflow: hidden;
    .fake-chat-inner{
      position: relative;
      .item{
        border-radius: 15px;
        background: #383838;
        color: #fff;
        padding: 10px 10px;
        margin-bottom: 5px;text-align: left;font-size: 24px;
      }
      span:nth-child(1) {
        color: #FFECBD;
      }
    }
  }
}
#lp-header{
  color: #fff;
  z-index: 2;
  position: absolute;
  width: 100%;top: 0;left: 0;
  .lp-ht-row{
  }
  .lp-ht-row:nth-child(1) {
    background: linear-gradient(rgba(0,0,0,.8),transparent);
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
  }
  .lp-ht-row:nth-child(1) span {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    //padding: 15px;
  }
  .lp-ht-row:nth-child(1) span:nth-child(1) strong {
    position: relative;
    font-size: 26px;
    font-weight: 400;
    width: 300px;
    height: 80px;
    overflow: hidden;
  }
  //.lp-ht-row:nth-child(1) span:nth-child(1) strong strong {
  //  width: 500%;
  //  position: absolute;
  //  animation: 10s lp-header-move infinite linear;
  //  left: 0;
  //  top: 0;
  //}
}
.lp-icon-group{
  z-index: 3;
  position: absolute;
  .lp-icon-item{
    //width: 60px;
    //height: 60px;
    //border: 1px solid #3c8ee5;
    //margin-bottom: 10px;

    color: #FDD80D;font-size: 24px;
    img{
      width: 80px;
      height: auto;display: block;
    }
  }
}
#lp-icon-1{
  top: 120px;
  left: 15px;
}
#lp-icon-4{
  bottom: 50px;
  right: 15px;
  .lp-icon-item{
    margin-bottom: 20px;
  }
}
.panel-wrapper {
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 3;
  //transition: all 0.8;
  .close-btn {
    text-align: center;
    padding: 10px;
    margin-bottom: 20px;
    span {
      background: rgba(0,0,0,.5);
      color: #fff;
      padding: 10px 15px;
      font-size: 26px;
      border-radius: 5px;
    }
  }
  .panel {
    background: rgba(0,0,0,.5);
    color: #fff;
    height: 720px;
    margin-bottom: 0;
    border: 1px solid transparent;
    border-radius: 8px;
    overflow: hidden;
    .panel-title {
      //transition: all .8;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-align: center;
      align-items: center; width: 100%;
      span {
        display: inline-block;
        width: 25%;padding: 20px 0;
      }
      .current {
        transition: all .8;
        background: rgba(0,0,0,.8);
      }
    }
    .panel-content{
      color: #fff;
      background: rgba(0,0,0,.8);
      //height: 100%;
      //overflow-y: scroll;
      //-webkit-overflow-scrolling: touch;
    }
  }
}
.gift-list {
  padding: 15px 0;text-align: left;margin-left: 5px;
  .gift-item{
    width: 160px;display: inline-block;margin: 0 12px 20px;text-align: center;
    img{
      width: 160px;height: 160px;background: #cccccc;display: block;margin-bottom: 20px;
    }
  }
}
#fake-chat-form {
  position: absolute;
  left: 24px;
  bottom: 60px;
  width: 350px;
  z-index: 2;
  border-radius: 30px;
  background: #383838;
  color: #fff;
  padding: 10px 10px;
  font-size: 24px;text-align: left;
}
.gift-box{
  position: absolute;
  left: 420px;
  bottom: 60px; z-index:2; border-radius: 30px;
  background: #383838;padding: 10px;
  img{
    width: 34px;height: auto;display: block;margin: 0 auto;
  }
}
.live-ranking-list{
  height: 610px;
  overflow-y: scroll;
}
.input-box{
  //position: fixed;
  //width: 100%;left: 0; bottom: 120px;
  background: #D0E1CB;
  .send-btn{
    width: 120px;
    color: #FFFFFF;
    background: #55BB3A;padding: 12px 0;
    border-radius: 32px;margin-left:26px;
  }
  .input-content{
    padding: 20px 20px;
    input{
      //width: 80%;margin: 0 15px;height: 60px;line-height: 60px;padding: 0 5px;
      width: 510px;margin-left: 10px;
      height: 66px;line-height: 66px;
      background: #FFFFFF;padding: 0 10px;
      border-radius: 33px;border: none;color: #282828;
    }
  }
  .browBox {
    width: 100%;
    height: 200px;
    background: #e6e6e6;
    //position: absolute;
    //bottom: 0px;
    overflow: scroll;
    ul {
      display: flex;
      flex-wrap: wrap;
      padding: 10px;
      li {
        width: 14%;
        margin: 5px 0;
        font-size: 42px;
        list-style: none;
        text-align: center;
      }
    }
  }
}
.live-chat-msgs{
  //padding-bottom: 120px;
  height: 510px;
  overflow-y: scroll;
  .item{
    padding: 15px 0;font-size: 26px;
    .item-content{
      .item-txt{
        padding: 5px 30px;text-align: left;font-size: 26px;
      }

    }
    .item-left{
      width: 16%;
      img {
        width: 80px;background: #cccccc;border-radius: 80px;height: 80px;
      }
    }
    .item-right{
      width: 80%;margin-left: 15px;
      .item-top{
        padding-bottom: 10px;
      }
      .translate{
        div{
          margin-right: 10px;color: #EDA10E;
          background: #FFFFFF;
          border: 2px solid #EDA10E;
          border-radius: 5px;padding: 5px 10px;
        }
        .active{
          background: #EDA10E;color:#ffffff;
        }
      }

    }
  }
}
.msg-height{
  height: 330px;
}
</style>
